import { Spin } from "antd";
import useQuizQuestions from "Pages/MySchedule/MyScheduledBeta/quiz/hooks/useQuizQuestions";
import PickQuestionsTable from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestionsTable";
import React, { useEffect } from "react";
import { BASE_URL, QUIZ } from "utilFunctions/Constants/urlConstants";

const QuizQuestions = ({ quiz }: any) => {
  if (!quiz?.id) return null;
  const { fetchQuizById, selectedQuestions, isLoading } = useQuizQuestions();
  const [qIdKey, setQIdKey] = React.useState<any>([]);
  useEffect(() => {
    if (!quiz?.id) return;
    fetchQuizById(BASE_URL + QUIZ + "/" + quiz.id);
  }, [quiz]);
  useEffect(() => {
    setQIdKey(selectedQuestions);
  }, [selectedQuestions]);
  return (
    <div>
      {isLoading ? <Spin></Spin> : null}
      <PickQuestionsTable
        data={selectedQuestions}
        pagination={false}
        qIdKey={qIdKey}
        setQIdKey={setQIdKey}
        checked={true}
        scroll={{
          x: "max-content",
          y: "calc(100vh - 470px)",
        }}
      ></PickQuestionsTable>
    </div>
  );
};

export default QuizQuestions;
